import React from 'react';
import { componentTypes, RadixUIRangeSlider } from '@white-nl/instantsearch-components';

import CollapsiblePanel from '../../utils/CollapsiblePanel';

export default function RangeSlider({
  results,
  slider,
  sliderSettings,
  additionalData,
}: componentTypes.RangeSliderPanelProps) {
  const { canRefine } = slider;
  const { panelSettings } = sliderSettings;

  if (!canRefine) {
    return null;
  }

  return (
    <CollapsiblePanel
      collapsiblePanelSettings={panelSettings?.collapsiblePanelSettings}
      header={panelSettings?.header}
      footer={panelSettings?.footer}
    >
      <div className="flex flex-col gap-y-3 pt-1">
        <RadixUIRangeSlider
          results={results}
          slider={slider}
          sliderSettings={sliderSettings}
          additionalData={additionalData}
        />
      </div>
    </CollapsiblePanel>
  );
}
